export default __webpack_public_path__ + "static/media/IconOutlook.8c3850e6.svg";